// Centralized brand constants for The Way Forward.solutions.
// `name` is the conversational brand ("The Way Forward"). `fullName` is the
// formal mark styled like the domain ("The Way Forward.solutions").
export const BRAND = {
  name: "The Way Forward",
  fullName: "The Way Forward.solutions",
  founder: "Joel M. Alexander",
  title: "Community Outreach Liaison",
  domain: "www.thewayforward.solutions",
  siteUrl: "https://www.thewayforward.solutions",
  bookTitle: "The Way Forward",
  bookSubtitle: "A Man's Transformation Guide to Health, Wealth & Wellness",
  bookReleaseLabel: "Father's Day · Sunday, June 21, 2026",
  phones: ["970-340-5900"],
  email: "Joel@thewayforward.solutions",
  assets: {
    // Official circular logo (white bg, black arched text + grayscale silhouette scene).
    logo: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/tt1abh7j_IMG_7359.jpeg",
    // Joel in white t-shirt, navy e-book release graphic (used in hero).
    joelNavyEbook: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/ubvys2gv_IMG_0771.PNG",
    // Joel red-suit headshot (used in About section).
    joelRedSuit: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/qqz6rjp2_IMG_7359%20%281%29.jpeg",
    // Joel red-suit e-book ad (alternative).
    joelRedEbook: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/pw8qe84t_IMG_0825.PNG",
    // Gold-on-navy "INSIDE THE BOOK" promo with silhouette walking into light.
    bookInsideGold: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/en7mea54_IMG_0772.PNG",
    // "Coming Sunday, June 21, 2026" book release graphic (navy + gold).
    bookReleaseNavy: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/j5kq4f5o_IMG_0750.PNG",
    // Book cover (distressed gray, off-brand colors — used sparingly).
    bookCover: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/i6mv8s0t_Sample%203%20WF%20%281%29.PNG",
    bookCoverLarge: "https://customer-assets.emergentagent.com/job_men-thrive-1/artifacts/sep6roaz_IMG_0746.PNG",
  },
  chapters: [
    "Breaking generational cycles",
    "Healing the man within",
    "Faith, discipline & purpose",
    "Health, wealth & wellness foundations",
    "Rebuilding with accountability",
    "Finding your foundation",
    "Becoming a leader in your family & community",
  ],
};
